module.exports = __webpack_public_path__ + "static/media/no-payment.ad4d86ea.png";